export const visit = (vm, at) => {
at({ "nl": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} van {{totalBytes}}" }, "fileSizeLimit": "Het bestand kan niet groter zijn dan {{size}}", "screenCapture": "Schermopname" } } });
};